import * as React from 'react'
import * as st from './badge.module.scss'
import { safeBoolean } from '../../utils/utils'

export interface UhdBadgeProps {
  isUhd?: boolean
}

//TODO: AVWebDetailPage-2972
export const Uhd = ({ isUhd }: UhdBadgeProps) => (
  safeBoolean(isUhd) &&
  (<span className={st.borderedTextBadge}>
    <span data-automation-id="uhd-badge">UHD</span>
  </span>) || null
)
